import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import PageLayout from "../../../layouts/PageLayout";
import FollowupProgressCard from "../../../components/cards/FollowupProgressCard";

export default function FollowUpDashboard() {
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Follow Up Dashboard</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>Home</Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="/family-follow-ups" className="mc-breadcrumb-link" style={{ color: "#077834" }}>FollowUps</Link>
                </li>
                <li className="mc-breadcrumb-item">Dashboard</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xl={12}>
          <FollowupProgressCard />
        </Col>
      </Row>
    </PageLayout>
  );
}
